import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./LandingPage.css";
import GrandSlamOffer from "../../images/GrandSlamOfferImage.png";

const LandingPage = ({ location }) => {
  const [timeLeft, setTimeLeft] = useState("Loading...");
  const [offerExpired, setOfferExpired] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const cancelMessage = queryParams.get("canceled") === "true";

  useEffect(() => {
    // const countdownDate = new Date("October 21, 2025 12:12:00 EDT").getTime(); // For testing purposes
    const countdownDate = new Date("October 22, 2025 19:00:00 EDT").getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = countdownDate - now;

      if (distance < 0) {
        setTimeLeft("Offer has Expired");
        setOfferExpired(true);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    };

    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="landing-page container">
      <div className="offer-details">
        <h1 className="offer-title">The Full Azure AI Bundle</h1>
        <h2 className="countdown">Only Available for: {timeLeft}</h2>
        <h4 className="offer-subtitle">Only Available until 7pm ET October 22nd, 2025</h4>
        <img src={GrandSlamOffer} alt="The Full Azure AI Bundle" className="offer-image" />

        <div className="pricing">
          <h3 className="original-price crossed-out">$6,323</h3>
          <h3 className="discounted-price crossed-out">$2,991</h3>
          <h2 className="final-price">$997</h2>
        </div>

        <p className="guarantee">
          Includes a 30-day money-back guarantee after the third Azure AI course is published.
        </p>

        {cancelMessage && (
          <p className="cancel-message">Something went wrong with your purchase. Please try again.</p>
        )}

        {offerExpired ? (
          <div className="expired-message">
            <p>The offer is no longer available.</p>
            <a href="https://azureinnovationstation.com" className="community-link">
              Join the Azure Innovation Station community for free to see when new offers are available!
            </a>
          </div>
        ) : (
          <form action={`${process.env.REACT_APP_API_URL}/api/checkout`} method="POST">
            <button type="submit" className="checkout-button">BUY IT HERE!</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default withRouter(LandingPage);